import { DatePipe, NgFor, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { Procedure } from 'fhir/r4';
import type { ProcedureReportDialogData } from './procedure-report-dialog.component';

@Component({
  selector: 'app-procedure-report-view-dialog',
  standalone: true,
  imports: [DatePipe, NgFor, NgIf, MatButtonModule, MatCardModule, MatChipsModule, MatDialogModule, MatIconModule],
  templateUrl: './procedure-report-view-dialog.component.html',
  styleUrl: './procedure-report-view-dialog.component.scss',
})
export class ProcedureReportViewDialogComponent {
  private readonly data = inject<ProcedureReportDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<ProcedureReportViewDialogComponent>);

  readonly procedure: Procedure = this.data.existingProcedure!;
  readonly serviceRequest = this.data.serviceRequest;

  get procedureName(): string {
    return this.procedure?.code?.text
      || this.procedure?.code?.coding?.[0]?.display
      || this.serviceRequest?.code?.text
      || this.serviceRequest?.code?.coding?.[0]?.display
      || 'Procedure';
  }

  get outcome(): string {
    return this.conceptText(this.procedure?.outcome);
  }

  get complications(): string[] {
    return this.conceptTexts(this.procedure?.complication);
  }

  get followUps(): string[] {
    return this.conceptTexts(this.procedure?.followUp);
  }

  get notes(): string[] {
    return (this.procedure?.note ?? []).map((note: any) => note?.text?.trim()).filter(Boolean);
  }

  close(): void {
    this.dialogRef.close();
  }

  private conceptText(value: any): string {
    return (value?.text || value?.coding?.[0]?.display || value?.coding?.[0]?.code || '').toString();
  }

  private conceptTexts(values: any[] | undefined): string[] {
    return (values ?? []).map((value) => this.conceptText(value)).filter(Boolean);
  }
}
